import {
  SizableText,
  XStack,
  YStack,
  YStackProps,
  interaction,
  styled
} from '@mythical/ui'
import { SmartLink } from 'app/components/primitive/SmartLink'
import { ALL_ACCESS_TIER, STARTER_TIER } from 'app/constants/tiers'
import ContentThumbnail from '../ContentThumbnail'
import { formatUpcomingDate } from './helpers'

type TierTag = { label: string; href: string }
const contentTierToTags = (contentTier: string | number): TierTag[] => {
  const tier = contentTier.toString()
  if (tier === '2')
    return [{ label: ALL_ACCESS_TIER.name, href: ALL_ACCESS_TIER.href }]
  return [{ label: 'Standard', href: STARTER_TIER.href }]
}

const CardWrapper = styled(YStack, {
  fs: 1,
  gap: '$2',
  fd: 'column',
  jc: 'flex-start',
  ai: 'flex-start',
  width: '100%',
})

const CardContent = styled(YStack, {
  gap: '$1.5',
  width: '100%',
  fs: 1,
  fg: 1,
  fd: 'column',
  jc: 'flex-start',
  ai: 'flex-start',
  $gtSm: {
    gap: '$2',
  },
})

const CardHeading = styled(SizableText, {
  color: '$fgPrimary',
  ff: '$body',
  size: '$1',
  fow: '500',
  $gtSm: {
    fow: '500',
    size: '$2',
  },
})

const CardText = styled(SizableText, {
  color: '$fgSecondary',
  ff: '$body',
  size: '$0.75',
  $gtSm: {
    size: '$1',
  },
})

export interface ContentCardUpcomingProps {
  id: string
  image: string
  title: string
  contentTier: string | number
  dateReleaseStart: string
  dateReleaseEnd?: string
  seriesOverlayUrl?: string
  href?: string
  wrapperProps?: YStackProps
  onNavigate?: () => void
}

const ContentCardUpcoming = ({
  image,
  title,
  href,
  dateReleaseStart,
  dateReleaseEnd,
  contentTier = '1',
  seriesOverlayUrl,
  wrapperProps,
  onNavigate,
}: ContentCardUpcomingProps) => {
  const formattedDate = formatUpcomingDate(dateReleaseStart, dateReleaseEnd)

  return (
    <CardWrapper {...wrapperProps}>
      <ContentThumbnail
        image={image}
        href={href}
        tag={formattedDate}
        seriesOverlayUrl={seriesOverlayUrl}
        sizes="(min-width: 661px) 350px, 170px"
      />

      <XStack jc="space-between" ai="flex-start" gap="$2" w="100%">
        <SmartLink
          Component={CardContent}
          href={href}
          onPress={onNavigate}
          {...(href && { ...interaction.opacity })}
        >
          {/* TODO: Content tier formatting */}
          {contentTier && (
            <CardText>
              {contentTierToTags(contentTier)
                .map((tag) => tag.label)
                .join(', ')}
            </CardText>
          )}
          <CardHeading>{title}</CardHeading>
        </SmartLink>
      </XStack>
    </CardWrapper>
  )
}

export default ContentCardUpcoming
